// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var orderRouter = {
  path: '/order',
  component: Layout,
  redirect: '/order/index',
  name: 'Order',
  alwaysShow: true,
  meta: {
    title: '订单',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/order/index');
    },
    name: 'OrderIndex',
    meta: {
      title: '订单'
    }
  }, {
    path: 'goodsOrderlist',
    component: function component() {
      return import('@/views/order/orderGoods');
    },
    name: 'goodsOrderlist',
    meta: {
      title: '商品订单'
    }
  }, {
    path: 'refund',
    component: function component() {
      return import('@/views/order/refund');
    },
    name: 'refund',
    meta: {
      title: '退单列表'
    }
  }, {
    path: 'summary',
    component: function component() {
      return import('@/views/order/fund/summary/index');
    },
    name: 'summaryFund',
    meta: {
      title: '订单汇总',
      icon: ''
    }
  }, {
    path: 'fundrefund',
    component: function component() {
      return import('@/views/order/fund/refund/index');
    },
    name: 'refundFund',
    meta: {
      title: '退单消息',
      icon: ''
    }
  }, {
    path: 'product',
    component: function component() {
      return import('@/views/order/product/index');
    },
    name: 'orderProduct',
    meta: {
      title: '订单收益',
      icon: ''
    }
  }, {
    path: 'training',
    name: 'orderProduct',
    meta: {
      title: '总裁班',
      icon: ''
    },
    component: function component() {
      return import('@/views/order/training');
    },
    children: [{
      path: 'meetings',
      name: 'orderMeetings',
      meta: {
        title: '培训管理',
        icon: '',
        noCache: true
      },
      component: function component() {
        return import('@/views/order/training/meetings/index.vue');
      },
      children: [{
        path: 'meetingsList',
        name: 'meetingsList',
        meta: {
          title: '培训会',
          noCache: true
        },
        component: function component() {
          return import('@/views/order/training/meetings/meetingsList/index.vue');
        }
      }, {
        path: 'editMeetings/:id?/',
        meta: {
          title: '编辑培训会',
          icon: '',
          activeMenu: "/order/training/meetings/meetingsList",
          noCache: true
        },
        name: 'editMeetings',
        component: function component() {
          return import('@/views/order/training/meetings/meetingsList/edit.vue');
        }
      }, {
        path: 'meetingsOrders',
        name: 'meetingsOrders',
        meta: {
          title: '参会订单',
          noCache: true
        },
        component: function component() {
          return import('@/views/order/training/meetings/meetingsOrders/index.vue');
        }
      }, {
        path: 'meetingsOrdersRefunds',
        name: 'meetingsOrdersRefunds',
        meta: {
          title: '参会退款',
          noCache: true
        },
        component: function component() {
          return import('@/views/order/training/meetings/meetingsOrders/refunds.vue');
        }
      }]
    }, {
      path: 'hotels',
      component: function component() {
        return import('@/views/order/training/hotels/index.vue');
      },
      name: 'hotels',
      meta: {
        title: '酒店管理',
        icon: '',
        noCache: true
      },
      children: [{
        path: 'hotelsList',
        name: 'orderHotels',
        meta: {
          title: '酒店列表',
          noCache: true
        },
        component: function component() {
          return import('@/views/order/training/hotels/hotelsList/index.vue');
        }
      }, {
        path: 'editHotels/:id?/',
        meta: {
          title: '编辑酒店',
          icon: '',
          activeMenu: "/order/training/hotels/hotelsList",
          noCache: true
        },
        name: 'editHotels',
        component: function component() {
          return import('@/views/order/training/hotels/hotelsList/edit.vue');
        }
      }, {
        path: 'hotelsOrders',
        name: 'hotelsOrders',
        meta: {
          title: '酒店订单',
          noCache: true
        },
        component: function component() {
          return import('@/views/order/training/hotels/hotelsOrders/index.vue');
        }
      }, {
        path: 'hotelsOrdersRefunds',
        name: 'hotelsOrdersRefunds',
        meta: {
          title: '酒店退款',
          noCache: true
        },
        component: function component() {
          return import('@/views/order/training/hotels/hotelsOrders/refunds.vue');
        }
      }]
    }, {
      path: 'teams',
      component: function component() {
        return import('@/views/order/training/teams');
      },
      name: 'orderTeams',
      meta: {
        title: '团队',
        icon: '',
        noCache: true
      }
    }]
  }, {
    path: 'goods',
    component: function component() {
      return import('@/views/order/goods/index');
    },
    name: 'goods',
    meta: {
      title: '双生发货',
      icon: ''
    }
  }, {
    path: 'orderreplenishment',
    component: function component() {
      return import('@/views/order/orderreplenishment/index');
    },
    name: 'orderreplenishment',
    meta: {
      title: '补货订单',
      icon: ''
    }
  }]
};
export default orderRouter;